import {dispatcher} from '@netx/core-next/instance/dispatcher';
import UserPrefs from '@netx/core-user/models/userPrefs';
import {useUserPreferencesStore} from '@netx/core-user-next/store/userPreferences';

export const userPrefs = new UserPrefs();

// we will import the store for now and keep it up to date
// this eliminates the need for the the store to import this _singleton_ file
// which, as noted below, brings along A LOT of baggage
userPrefs.on('sync change reset', () => {
	useUserPreferencesStore.setState({userPreferences: {...userPrefs.rawPrefs}});
});

// hack for not having to import this file, and in return the model, which imports the netx-model/netx-collection which has
// so much baggage
// the store can use this along with all the old backbone code that already uses it
dispatcher.on(
	'user:prefs:set',
	(pref: string, value: string | number | boolean | null = null) => {
		userPrefs.setUserPreference(pref, value);
		// continue triggering success event to be safe
		dispatcher.trigger('user:prefs:set:success', pref, value);
	},
);

export default userPrefs;
